export const convertSearch = (search: string | null) => {
  if (!search) return '';
  const regex = /(\+7\B)|(\+7\b)|[()-]/g;
  return search.replace(regex, '').trim();
};
